import React from 'react';
import Modal from 'react-modal';
import './LoseModal.css'
import { useTranslation } from 'react-i18next';

export const LoseModal = (props: any) => {
  const modalClassName = props.isOpen ? 'modalLose active' : 'modalLose';
  const {i18n, t} = useTranslation();

  return (
      <Modal
        isOpen={props.isOpen}
        onRequestClose={props.onClose}
        contentLabel="Derrota Modal"
        ariaHideApp={false}
        className={modalClassName}
      >
        <div className='lose'>
          <button onClick={props.onClose} className="close-button">×</button>
          <h1>{t('modal-lose.title')}</h1>
          <h1>{t('modal-lose.subTitle')}</h1>
          <span>{t('modal-lose.span')}</span>
          <img className='left' src='jinx.png'></img>
          <img className='right' src='silco.png'></img>
        </div>
      </Modal>
  );
};